import { Component, Inject,   OnInit } from '@angular/core';
import { FormBuilder, FormGroup,  Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Vendors } from 'app/_models/vendors';
import { ToastrService } from 'ngx-toastr';
import { CrudVendorService } from 'app/_services/MasterCrudOps/crud-vendor.service';
declare const swal: any;


@Component({
  selector: 'app-editvendor',
  templateUrl: './editvendor.component.html',
  styleUrls: ['./editvendor.component.css']
})

export class EditvendorComponent  implements OnInit {
  editVendorForm: FormGroup;
  editVendor: Vendors;
  pageNumber: number;
  pageSize: number;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly  toastr: ToastrService,
    private readonly crudVendorService:CrudVendorService,
    private readonly dialogRef: MatDialogRef<EditvendorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.editVendor = JSON.parse(JSON.stringify(data.vendor));
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;

  }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.editVendorForm = this.formBuilder.group({
      vendorName: [this.editVendor.vendorName, [Validators.required, Validators.maxLength(50)]],
      description: [this.editVendor.description, [Validators.required, Validators.maxLength(100)]],
      address: [this.editVendor.address, [Validators.required, Validators.maxLength(250)]],
      emailIds: [this.editVendor.emailIds, [Validators.required, this.emailListValidator]],
      contactNumbers: [this.editVendor.contactNumbers, [Validators.required, this.contactNumberValidator]]
    });
  }


  emailListValidator(control: any): { [key: string]: any } | null {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const emailIds = control.value ?? '';
    const emails = emailIds.split(';').map((email: string) => email.trim());
    const invalidEmails = emails.filter(email => !emailPattern.test(email));
    return invalidEmails.length ? { invalidEmailIds: true } : null;
  }

  contactNumberValidator(control: any): { [key: string]: any } | null {
    const contactNumberPattern = /^\d{10}$/;
    const contactNumbers = control.value ?? '';
    const numbers = contactNumbers.split(';').map((number: string) => number.trim());
    const invalidNumbers = numbers.filter(number => !contactNumberPattern.test(number));
    return invalidNumbers.length ? { invalidContactNumbers: true } : null;
  }

  saveVendor() {
    swal({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'YES, Update IT!'
    }).then((result) => {
      if (result === true) {
        this.updateVendor()
      }
      else {
        this.toastr.info('result not saved')
      }
    })
  }

  updateVendor() {
   let model = {vendorCode: this.editVendor.vendorCode, vendorName: this.editVendorForm.value.vendorName, 
    description: this.editVendorForm.value.description,
    address: this.editVendorForm.value.address, emailIds: this.editVendorForm.value.emailIds, ContactNumbers: this.editVendorForm.value.contactNumbers };
    this.crudVendorService.updateVendor(model )
    .subscribe(
      data => {     
        if (data.didError) {
          swal({
            title: '',
            text: data.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info'
          });
        }
        else {
          this.dialogRef.close(true);
          swal({
            title: '',
            text: data.message,
            type: 'success',
            confirmButtonClass: 'btn btn-info'
          });
          let result = {
            status: true,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize
          };
          this.dialogRef.close(result);
        }
      },
(error) => 
    {
       let errorMessage =
          error.error?.title ??
          error.error ??
          "Something went wrong. Please contact admin.";

        // Check if it's a validation error response with the `errors` object
        if (error.error?.errors) {
          const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
          if (allErrors.length > 0) {
            errorMessage = allErrors[0]; // Use the first validation message
          }
        } else if (typeof error.error === "string") {
          errorMessage = error.error;
        } else if (error.error?.title) {
          errorMessage = error.error.title;
        }

      swal({
        title: '',
        text: errorMessage,
        type: 'error',
        confirmButtonClass: 'btn btn-info'
      });
    }
)

}

  close() {
    let result = {
      status: false,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize
    };
    this.dialogRef.close(result);
  }

}

 